<script>

    /**
     * @typedef Props
     * @property {number} id
     * @property {"user"|"consumer"} entityType
     */

    /**
     * @typedef ImportantToFor
     * @property {string} important_to - Important TO Me
     * @property {string} important_to_support - How to Support What is Important TO Me
     */

    /**
     * @typedef OnePageDescriptionForm
     * @property {string} purpose - Purpose of the One Page Description
     * @property {string[]} people_like_about_me - Great Things People Say/Like About Me
     * @property {string[]} traits_like - Personality Traits I Like to be Around
     * @property {string[]} traits_dislike - Personality Traits I Don't Like to be Around
     * @property {string[]} nice_to_have - Nice to Have (Shared Interests)
     * @property {ImportantToFor[]} - Important TO Me
     */

    import dressing from "@intellectability/platform-common";
    import {AutoUpdateInput, Button, ExportButtons, Icon} from "@intellectability/platform-common/sv";
    import {ACTIONS} from "@intellectability/platform-common/constants";
    import {userSecurity} from "@intellectability/platform-common/sv/state";
    import {actionCheck, create_security_error} from "@intellectability/platform-common/utils";

    const {
        PERSON_ONE_PAGE_DESCRIPTION_VIEW,
        PERSON_ONE_PAGE_DESCRIPTION_EDIT,
        PERSON_ONE_PAGE_DESCRIPTION_PDF,
        USER_ONE_PAGE_DESCRIPTION_VIEW,
        USER_ONE_PAGE_DESCRIPTION_EDIT
    } = ACTIONS;

    /**
     * @type Props
     */
    let {id, entityType, isActive = false} = $props();

    let hasAccess = $derived(actionCheck(userSecurity.userActions));

    /**
     * @type OnePageDescriptionForm
     */
    let formData = $state.raw({});
    let changeData = $state.raw([]);

    let canEdit = $derived.by(function () {

        // person/user must be active to edit
        if (!isActive) {
            return false;
        }

        switch (entityType) {
            case "user": {
                return hasAccess(USER_ONE_PAGE_DESCRIPTION_EDIT);
            }
            case "consumer": {
                return hasAccess(PERSON_ONE_PAGE_DESCRIPTION_EDIT);
            }
            default: {
                return false;
            }
        }

    });
    let disabled = $derived(!canEdit);

    $effect(function () {

        if (hasAccess(PERSON_ONE_PAGE_DESCRIPTION_VIEW)) {

            const endpoint = "";

        }
        else {
            dressing.api.report_security_error(create_security_error(
                "OnePageDescription.svelte",
                "OnePageDescription",
                PERSON_ONE_PAGE_DESCRIPTION_VIEW,
                "Access error with entityType:" + entityType)
            ).finally(function () {
                dressing.api.logout();
            });
        }
    });

    let autoupdate = false;

    let fields = [
        {
            fieldNames: ["people_like_about_me"],
            limit: 50
        }
    ];
</script>

<div class="d-flex align-items-center justify-content-between mb-3">
    <h2>
        <Icon icon="file-user" class="me-1"/>
        One Page Description
    </h2>

    <div>
        <ExportButtons show={["pdf"]} href={`/?action=${PERSON_ONE_PAGE_DESCRIPTION_PDF}&id=${id}`}/>
    </div>


</div>

<!-- Change Log -->
<div class="mb-3">
    <wa-details disabled={changeData.length === 0}>
        <h4 slot="summary">Change Log</h4>
        <wa-icon name="square-plus" slot="expand-icon" variant="regular"></wa-icon>
        <wa-icon name="square-minus" slot="collapse-icon" variant="regular"></wa-icon>
        <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
                <th>Date Changed</th>
                <th>Changed By</th>
            </tr>
            </thead>
            <tbody>
            <tr>
                {#each changeData as change}
                    <td>{change.date ?? ""}</td>
                    <td>{change.user ?? ""}</td>
                {/each}
            </tr>
            </tbody>
        </table>
    </wa-details>
</div>

<div class="mb-3">
    <div class="mb-3">
        {@render purposeCallout()}
    </div>
    <div>
        <label class="form-label" for="purpose">
            Purpose of the One Page Description
        </label>
        <div style="margin: 0 2px">
            <AutoUpdateInput
                    defaultValue={"Tacos"}
                    id="purpose"
                    {autoupdate}
                    class="mt-0"
                    {disabled}
                    type="textarea"
            />
        </div>
    </div>
</div>
<div class="mb-3">
    <div class="mb-3">
        {@render peopleLikeCallout()}
    </div>
    <div class="">
        <wa-callout variant="neutral">
            <div>
                <!--{#each formData["people_like_about_me"] as input}-->
                <!--    <AutoUpdateInput-->
                <!--            {autoupdate}-->
                <!--            {input}-->
                <!--            label="Purpose of the One Page Description"-->
                <!--            charLimit={50}-->
                <!--            type="text"-->
                <!--    />-->
                <!--{/each}-->
                <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions -->
                <wa-button
                        variant="success"
                        size="small"
                        {disabled}
                        onclick={function(fieldName, limit, ) {
                            // todo: create a record and insert into the page
                        }}>
                    <wa-icon slot="prefix" name="plus" size="small"></wa-icon>
                    Add
                </wa-button>
            </div>
        </wa-callout>
    </div>
</div>
<div class="mb-3">
    <div class="mb-3">
        {@render personalityTraitsILikeCallout()}
    </div>
    <div class="">
        <wa-callout variant="neutral">
            <div>
                <!--{#each formData["people_like_about_me"] as input}-->
                <!--    <AutoUpdateInput-->
                <!--            {autoupdate}-->
                <!--            {input}-->
                <!--            label="Purpose of the One Page Description"-->
                <!--            charLimit={50}-->
                <!--            type="text"-->
                <!--    />-->
                <!--{/each}-->
                <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions -->
                <wa-button
                        variant="success"
                        size="small"
                        {disabled}
                        onclick={function(fieldName, limit, ) {
                    // todo: create a record and insert into the page
                    }}>
                    <wa-icon slot="prefix" name="plus" size="small"></wa-icon>
                    Add
                </wa-button>
            </div>
        </wa-callout>
    </div>
</div>
<div class="mb-3">
    <div class="mb-3">
        {@render personalityTraitsIDontLikeCallout()}
    </div>
    <div class="">
        <wa-callout variant="neutral">
            <div>
                <!--{#each formData["people_like_about_me"] as input}-->
                <!--    <AutoUpdateInput-->
                <!--            {autoupdate}-->
                <!--            {input}-->
                <!--            label="Purpose of the One Page Description"-->
                <!--            charLimit={50}-->
                <!--            type="text"-->
                <!--    />-->
                <!--{/each}-->
                <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions -->
                <wa-button
                        variant="success"
                        size="small"
                        {disabled}
                        onclick={function(fieldName, limit, ) {
                            // todo: create a record and insert into the page
                        }}>
                    <wa-icon slot="prefix" name="plus" size="small"></wa-icon>
                    Add
                </wa-button>
            </div>
        </wa-callout>
    </div>
</div>
<div class="mb-3">
    <div class="mb-3">
        {@render niceToHaveCallout()}
    </div>
    <div class="">
        <wa-callout variant="neutral">
            <div>
                <!--{#each formData["people_like_about_me"] as input}-->
                <!--    <AutoUpdateInput-->
                <!--            {autoupdate}-->
                <!--            {input}-->
                <!--            label="Purpose of the One Page Description"-->
                <!--            charLimit={50}-->
                <!--            type="text"-->
                <!--    />-->
                <!--{/each}-->
                <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions -->
                <wa-button
                        variant="success"
                        size="small"
                        {disabled}
                        onclick={function(fieldName, limit, ) {
                            // todo: create a record and insert into the page
                        }}>
                    <wa-icon slot="prefix" name="plus" size="small"></wa-icon>
                    Add
                </wa-button>
            </div>
        </wa-callout>
    </div>
</div>
<div class="mb-3">
    <div class="mb-3">
        {@render importantToMeCallout()}
    </div>
    <div class="">
        <wa-callout variant="neutral">
            <div>
                <!--{#each formData["people_like_about_me"] as input}-->
                <!--    <AutoUpdateInput-->
                <!--            {autoupdate}-->
                <!--            {input}-->
                <!--            label="Purpose of the One Page Description"-->
                <!--            charLimit={50}-->
                <!--            type="text"-->
                <!--    />-->
                <!--{/each}-->
                <!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions -->
                <wa-button
                        variant="success"
                        size="small"
                        {disabled}
                        onclick={function(fieldName, limit, ) {
                            // todo: create a record and insert into the page
                        }}>
                    <wa-icon slot="prefix" name="plus" size="small"></wa-icon>
                    Add
                </wa-button>
            </div>
        </wa-callout>
    </div>
</div>

{@render dingbat()}

{#snippet dingbat()}
    <div class="dingbat">
        <wa-icon name="0" family="classic" variant="solid" class=""
                 style="color: var(--hrst-secondary-400); font-size: 1rem;"></wa-icon>
        <wa-icon name="0" family="classic" variant="solid" class="mx-1"
                 style="color: var(--hrst-secondary-400); font-size: 1.2rem;"></wa-icon>
        <wa-icon name="0" family="classic" variant="solid" class=""
                 style="color: var(--hrst-secondary-400); font: 1rem;"></wa-icon>
    </div>
    <style>
        div.dingbat {
            display: flex;
            justify-content: center;
            align-items: baseline;
            width: 100%;
            margin: 3rem 0;
        }
    </style>
{/snippet}

{#snippet purposeCallout()}
    <wa-callout>
        <ul class="list-group list-group-flush">
            {#if entityType === "user"}
                <li class="list-group-item">
                    Be specific in all categories
                </li>
                <li class="list-group-item">
                    Keep it in common language. No system-speak.
                </li>
                <li class="list-group-item">
                    Help is always available at <a class="link-primary" href="mailto:PCThelp@replacingrisk.com">PCThelp@replacingrisk.com</a>.
                    Reach out!
                </li>
            {:else if entityType === "consumer"}
                <li class="list-group-item">
                    Information for the One Page Description should be pulled from the Electronic
                    Person Centered Description
                </li>
                <li class="list-group-item">Use the six discovery skills for information. Don't just ask.</li>
                <li class="list-group-item">Be specific in all categories</li>
                <li class="list-group-item">Keep it in common language. No system-speak.</li>
                <li class="list-group-item">This is written for anyone who supports the person. Make sure anyone can
                    understand it.
                </li>
                <li class="list-group-item">Help is always available at
                    <a class="link-primary" href="mailto:PCThelp@replacingrisk.com">
                        PCThelp@replacingrisk.com
                    </a>. Reach out!
                </li>
            {/if}
        </ul>
    </wa-callout>
{/snippet}

{#snippet peopleLikeCallout()}
    <wa-callout>
        <h6>Things to Remember</h6>
        <ul class="list-group list-group-flush">
            {#if entityType === "user"}
                <li class="list-group-item">
                    These are great things people say they like
                    about me (whether I believe it about myself or not.)
                </li>
            {:else if entityType === "consumer"}
                <li class="list-group-item">
                </li>
                <li class="list-group-item">
                </li>
            {/if}
        </ul>
    </wa-callout>
{/snippet}

{#snippet personalityTraitsILikeCallout()}
    <wa-callout>
        <h6>Things to Remember</h6>
        <ul class="list-group list-group-flush">
            {#if entityType === "user"}
                <li class="list-group-item">
                    Be specific, e.g. <em>Silly sense of humor</em> not just <em>Funny</em>
                </li>
            {:else if entityType === "consumer"}
                <li class="list-group-item">
                </li>
                <li class="list-group-item">
                </li>
            {/if}
        </ul>
    </wa-callout>
{/snippet}

{#snippet personalityTraitsIDontLikeCallout()}
    <wa-callout>
        <h6>Things to Remember</h6>
        <ul class="list-group list-group-flush">
            {#if entityType === "user"}
                <li class="list-group-item">
                    Be specific, e.g. <em>Not too chatty</em>
                </li>
            {:else if entityType === "consumer"}
                <li class="list-group-item">
                </li>
                <li class="list-group-item">
                </li>
            {/if}
        </ul>
    </wa-callout>
{/snippet}

{#snippet niceToHaveCallout()}
    <wa-callout>
        <h6>Things to Remember</h6>
        <ul class="list-group list-group-flush">
            {#if entityType === "user"}
                <li class="list-group-item">
                    Be specific: i.e. what kind of music, which type of sports, what kind of art
                </li>
            {:else if entityType === "consumer"}
                <li class="list-group-item">
                </li>
                <li class="list-group-item">
                </li>
            {/if}
        </ul>
    </wa-callout>
{/snippet}

{#snippet importantToMeCallout()}
    <wa-callout>
        <h6>Things to Remember</h6>
        <ul class="list-group list-group-flush">
            {#if entityType === "user"}
                <li class="list-group-item">
                    Important To
                    <ul>
                        <li>These are things that matter to you. It does not have to make sense to others.</li>
                        <li>Be Specific, i.e. Which places to go, what things to do or have, who matters</li>
                    </ul>
                </li>
                <li class="list-group-item">
                    How to Support What Is Important TO Me
                    <ul>
                        <li>Specific things others need to do to help with Important To</li>
                    </ul>
                </li>
            {:else if entityType === "consumer"}
                <li class="list-group-item">
                </li>
                <li class="list-group-item">
                </li>
            {/if}
        </ul>
    </wa-callout>
{/snippet}

<style>
    ul.list-group {
        --bs-list-group-bg: transparent;
    }

    wa-details::part(icon) {
        color: var(--hrst-primary-500)
    }
</style>